import { useRef } from 'react';
import { useDropzone } from 'react-dropzone';

function FileUpload({ required, name }) {

    const hiddenInputRef = useRef(null);

    const { getRootProps, getInputProps, open, acceptedFiles } = useDropzone({
        onDrop: (incomingFiles) => {
            if (hiddenInputRef.current) {
                // Note the specific way we need to munge the file into the hidden input
                // https://stackoverflow.com/a/68182158/1068446
                const dataTransfer = new DataTransfer();
                incomingFiles.forEach((v) => {
                    dataTransfer.items.add(v);
                });
                hiddenInputRef.current.files = dataTransfer.files;
            }
        }
    });

    const files = acceptedFiles.map(file => (
        file.path
    ));

    return (
        <div className="dropzone-container" onClick={open}>
            <div {...getRootProps({ className: 'dropzone' })}>
                <input type="file" accept="image/png, image/jpeg" name={name} required={required} style={{ opacity: 0 }} ref={hiddenInputRef} />
                <input {...getInputProps()} />
                <p>Drag and drop logo image here, or click to select files</p>
            </div>
        </div>
    );
}

export default FileUpload;
